/* ════════════════════════════════════════
   ImpacTH — Main JavaScript v4
   Full mega menu catalogue + nav + utils
   ════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── NAV SCROLL SHADOW ── */
  var nav = document.getElementById('main-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('raised', window.scrollY > 10);
    });
  }

  /* ── MEGA MENUS — open/close ── */
  var triggers = document.querySelectorAll('[data-mega]');
  var megas = document.querySelectorAll('.mega-wrap');
  var closeTimeout = null;

  function openMega(id) {
    clearTimeout(closeTimeout);
    megas.forEach(function(m) { m.classList.remove('active'); });
    triggers.forEach(function(t) { t.classList.remove('open'); });
    var target = document.getElementById('mega-' + id);
    var trigger = document.querySelector('[data-mega="' + id + '"]');
    if (target) target.classList.add('active');
    if (trigger) trigger.classList.add('open');
  }

  function closeMegas() {
    closeTimeout = setTimeout(function() {
      megas.forEach(function(m) { m.classList.remove('active'); });
      triggers.forEach(function(t) { t.classList.remove('open'); });
    }, 180);
  }

  triggers.forEach(function(trigger) {
    trigger.addEventListener('mouseenter', function() {
      openMega(this.getAttribute('data-mega'));
    });
  });

  megas.forEach(function(mega) {
    mega.addEventListener('mouseenter', function() { clearTimeout(closeTimeout); });
    mega.addEventListener('mouseleave', closeMegas);
  });

  if (nav) {
    nav.addEventListener('mouseleave', closeMegas);
  }

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav') && !e.target.closest('.mega-wrap')) {
      megas.forEach(function(m) { m.classList.remove('active'); });
      triggers.forEach(function(t) { t.classList.remove('open'); });
    }
  });

  /* ── LANGUAGE PICKER ── */
  var langPicker = document.getElementById('lang-picker');
  if (langPicker) {
    langPicker.addEventListener('click', function(e) {
      e.stopPropagation();
      this.classList.toggle('open');
    });
    document.addEventListener('click', function() {
      if (langPicker) langPicker.classList.remove('open');
    });
  }

  /* ── MOBILE MENU ── */
  var mobileToggle = document.getElementById('mobile-menu-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileOverlay = document.getElementById('mobile-menu-overlay');
  var mobileClose = document.getElementById('mobile-menu-close');

  function openMobile() {
    if (mobileMenu) mobileMenu.classList.add('active');
    if (mobileOverlay) mobileOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobile() {
    if (mobileMenu) mobileMenu.classList.remove('active');
    if (mobileOverlay) mobileOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobile);
  if (mobileClose) mobileClose.addEventListener('click', closeMobile);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobile);


  /* ══════════════════════════════════════════════════════════
     MEGA MENU CATALOGUE — Full dynamic logic
     ══════════════════════════════════════════════════════════ */

  var catSections = document.querySelectorAll('.mega-cat-section');

  var CATALOGUE_DATA = {

    personnalisable: {
      title: 'Personnalisable',
      color: '#18A06A',
      cats: [
        {
          id: 'textile', icon: '👕', label: 'Textile',
          sub: 'T-shirts, polos, sweats, vestes, pantalons, workwear, sport',
          href: '/collections/textile',
          preview: {
            titre: 'Textile personnalisable',
            tag: 'Broderie · Sérigraphie · Flocage · Transfert',
            img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&q=80',
            groups: [
              { label: 'T-shirts', items: [
                {name: 'T-shirt col rond', href: '/collections/t-shirts'},
                {name: 'T-shirt technique', href: '/collections/t-shirts'},
                {name: 'T-shirt manches longues', href: '/collections/t-shirts'}
              ]},
              { label: 'Polos', items: [
                {name: 'Polo manches courtes', href: '/collections/polos'},
                {name: 'Polo manches longues', href: '/collections/polos'},
                {name: 'Polo femme', href: '/collections/polos'}
              ]},
              { label: 'Sweats', items: [
                {name: 'Sweat col rond', href: '/collections/sweats'},
                {name: 'Hoodie zippé', href: '/collections/sweats'},
                {name: 'Sweat molleton', href: '/collections/sweats'}
              ]},
              { label: 'Vestes', items: [
                {name: 'Softshell', href: '/collections/vestes'},
                {name: 'Polaire', href: '/collections/vestes'},
                {name: 'Coupe-vent', href: '/collections/vestes'}
              ]},
              { label: 'Pantalons', items: [
                {name: 'Pantalon de travail', href: '/collections/pantalons'},
                {name: 'Bermuda', href: '/collections/pantalons'},
                {name: 'Legging sport', href: '/collections/pantalons'}
              ]},
              { label: 'Sport', items: [
                {name: 'T-shirt technique', href: '/collections/sport-textile'},
                {name: 'Kit de sport', href: '/collections/sport-textile'},
                {name: 'Survêtement', href: '/collections/sport-textile'}
              ]},
              { label: 'Workwear →', items: [
                {name: 'Haute visibilité', href: '/collections/haute-visibilite'},
                {name: 'Hôtellerie et restauration', href: '/collections/hotellerie-et-restauration'},
                {name: 'Santé et esthétique', href: '/collections/sante-et-esthetique'},
                {name: 'Industrie', href: '/collections/industrie-services'},
                {name: 'Ignifuge', href: '/collections/ignifuge'},
                {name: 'Industrie alimentaire', href: '/collections/industrie-alimentaire'},
                {name: 'Chaussures pro', href: '/collections/chaussures-professionnelles'},
              ]}
            ]
          }
        },
        {
          id: 'sacs', icon: '👜', label: 'Sacs & Tote bags',
          sub: 'Tote bags, sacs à dos, pochettes',
          href: '/collections/sacs-tote-bags',
          preview: {
            titre: 'Sacs & Tote bags',
            tag: 'Sérigraphie · Broderie · Sublimation',
            img: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=400&q=80',
            groups: [
              { label: 'Tote bags', items: [
                {name: 'Tote bag coton 140g', href: '/collections/tote-bags'},
                {name: 'Tote bag bio GOTS', href: '/collections/tote-bags'},
                {name: 'Tote bag canvas épais', href: '/collections/tote-bags'}
              ]},
              { label: 'Sacs à dos', items: [
                {name: 'Sac à dos 20L', href: '/collections/sacs-a-dos'},
                {name: 'Sac laptop 15"', href: '/collections/sacs-a-dos'},
                {name: 'Sac à dos sport', href: '/collections/sacs-a-dos'}
              ]},
              { label: 'Sport & Pochettes', items: [
                {name: 'Sac de sport', href: '/collections/sacs-sport'},
                {name: 'Pochette documents', href: '/collections/pochettes'},
                {name: 'Trousse zippée', href: '/collections/pochettes'}
              ]}
            ]
          }
        },
        {
          id: 'gourdes-mugs', icon: '☕', label: 'Gourdes, Mugs & Verres',
          sub: 'Gourdes, mugs, gobelets, lunch boxes',
          href: '/collections/gourdes-mugs',
          preview: {
            titre: 'Gourdes, Mugs & Verres',
            tag: 'Gravure laser · Sérigraphie · Sublimation',
            img: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?w=400&q=80',
            groups: [
              { label: 'Gourdes', items: [
                {name: 'Gourde inox 500ml', href: '/collections/gourdes'},
                {name: 'Gourde sport', href: '/collections/gourdes'},
                {name: 'Bouteille verre', href: '/collections/gourdes'}
              ]},
              { label: 'Mugs', items: [
                {name: 'Mug céramique 330ml', href: '/collections/mugs'},
                {name: 'Mug thermos', href: '/collections/mugs'},
                {name: 'Mug sublimation', href: '/collections/mugs'}
              ]},
              { label: 'Gobelets & Lunch', items: [
                {name: 'Gobelet réutilisable', href: '/collections/gobelets'},
                {name: 'Gobelet double paroi', href: '/collections/gobelets'},
                {name: 'Lunch box', href: '/collections/lunch-boxes'}
              ]}
            ]
          }
        },
        {
          id: 'stylos-papeterie', icon: '🖊️', label: 'Stylos & Papeterie',
          sub: 'Stylos, carnets, agendas, blocs-notes',
          href: '/collections/papeterie',
          preview: {
            titre: 'Stylos & Papeterie',
            tag: 'Gravure · Sérigraphie · Impression numérique',
            img: 'https://images.unsplash.com/photo-1531346878377-a5be20888e57?w=400&q=80',
            groups: [
              { label: 'Stylos', items: [
                {name: 'Stylo bille métal', href: '/collections/stylos'},
                {name: 'Stylo roller', href: '/collections/stylos'},
                {name: 'Crayon personnalisé', href: '/collections/crayons'}
              ]},
              { label: 'Carnets', items: [
                {name: 'Carnet A5 souple', href: '/collections/carnets'},
                {name: 'Carnet rigide', href: '/collections/carnets'},
                {name: 'Agenda annuel', href: '/collections/agendas'}
              ]},
              { label: 'Blocs-notes', items: [
                {name: 'Bloc A4 50 feuilles', href: '/collections/papeterie'},
                {name: 'Conférencier', href: '/collections/papeterie'},
                {name: 'Set stylo + carnet', href: '/collections/papeterie'}
              ]}
            ]
          }
        },
        {
          id: 'high-tech', icon: '💻', label: 'High-Tech',
          sub: 'Clés USB, enceintes, chargeurs, powerbanks',
          href: '/collections/high-tech',
          preview: {
            titre: 'High-Tech',
            tag: 'Gravure laser · Impression UV · Doming',
            img: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&q=80',
            groups: [
              { label: 'USB & Stockage', items: [
                {name: 'Clé USB 16Go', href: '/collections/cles-usb'},
                {name: 'Clé USB bois', href: '/collections/cles-usb'},
                {name: 'Clé USB-C', href: '/collections/cles-usb'}
              ]},
              { label: 'Audio', items: [
                {name: 'Enceinte bluetooth', href: '/collections/enceintes'},
                {name: 'Écouteurs TWS', href: '/collections/enceintes'},
                {name: 'Casque audio', href: '/collections/enceintes'}
              ]},
              { label: 'Énergie', items: [
                {name: 'Chargeur sans fil', href: '/collections/chargeurs'},
                {name: 'Powerbank 5000mAh', href: '/collections/powerbanks'},
                {name: 'Powerbank 10000mAh', href: '/collections/powerbanks'}
              ]}
            ]
          }
        },
        {
          id: 'cadeaux', icon: '🎁', label: "Cadeaux d'affaires",
          sub: 'Coffrets, parapluies, bougies, soins',
          href: '/collections/cadeaux',
          preview: {
            titre: "Cadeaux d'affaires",
            tag: 'Sur devis · Coffrets personnalisés',
            img: 'https://images.unsplash.com/photo-1512909006721-3d6018887383?w=400&q=80',
            groups: [
              { label: 'Coffrets', items: [
                {name: 'Coffret bien-être', href: '/collections/coffrets'},
                {name: 'Coffret gastronomie', href: '/collections/coffrets'},
                {name: 'Coffret thé & café', href: '/collections/coffrets'}
              ]},
              { label: 'Parapluies', items: [
                {name: 'Parapluie classique', href: '/collections/parapluies'},
                {name: 'Parapluie pliable', href: '/collections/parapluies'},
                {name: 'Parapluie coupe-vent', href: '/collections/parapluies'}
              ]},
              { label: 'Bien-être', items: [
                {name: 'Bougie personnalisée', href: '/collections/bougies'},
                {name: 'Set soins', href: '/collections/bougies'},
                {name: 'Plaid brodé', href: '/collections/cadeaux'}
              ]}
            ]
          }
        },
        {
          id: 'accessoires-divers', icon: '🔧', label: 'Accessoires & Divers',
          sub: 'Porte-clés, outils, sport, jeux',
          href: '/collections/accessoires-divers',
          preview: {
            titre: 'Accessoires & Divers',
            tag: 'Gravure · Sérigraphie · Doming',
            img: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=400&q=80',
            groups: [
              { label: 'Porte-clés & Outils', items: [
                {name: 'Porte-clés métal', href: '/collections/porte-cles'},
                {name: 'Outil multifonction', href: '/collections/outils'},
                {name: 'Torche LED', href: '/collections/outils'}
              ]},
              { label: 'Sport & Plein air', items: [
                {name: 'Accessoires sport', href: '/collections/sport'},
                {name: 'Lunettes soleil', href: '/collections/sport'},
                {name: 'Lanyard', href: '/collections/lanyards'}
              ]},
              { label: 'Enfants & Jeux', items: [
                {name: 'Set coloriage', href: '/collections/enfants-jeux'},
                {name: 'Jeux de bureau', href: '/collections/enfants-jeux'},
                {name: 'Peluches', href: '/collections/enfants-jeux'}
              ]}
            ]
          }
        },
        {
          id: 'france', icon: '🇫🇷', label: 'Made In France',
          sub: 'Produits fabriqués en France',
          href: '/collections/made-in-france',
          preview: {
            titre: 'Made In France',
            tag: 'Fabrication 100% française',
            img: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=400&q=80',
            groups: [
              { label: 'Textile France', items: [
                {name: 'Polo made in France', href: '/collections/made-in-france'},
                {name: 'T-shirt façon locale', href: '/collections/made-in-france'},
                {name: 'Sweat cousu en France', href: '/collections/made-in-france'}
              ]},
              { label: 'Goodies France', items: [
                {name: 'Stylo fabriqué FR', href: '/collections/made-in-france'},
                {name: 'Carnet Clairefontaine', href: '/collections/made-in-france'},
                {name: 'Mug porcelaine Limoges', href: '/collections/made-in-france'}
              ]},
              { label: 'Alimentaire', items: [
                {name: 'Confitures artisanales', href: '/collections/made-in-france'},
                {name: 'Miel de France', href: '/collections/made-in-france'},
                {name: 'Biscuits régionaux', href: '/collections/made-in-france'}
              ]}
            ]
          }
        },
        {
          id: 'eco', icon: '🌿', label: 'Éco-responsables',
          sub: 'Recyclé, bio, circuits courts',
          href: '/collections/eco-responsables',
          preview: {
            titre: 'Éco-responsables',
            tag: 'RPET · Bambou · Coton bio · Recyclé',
            img: 'https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=400&q=80',
            groups: [
              { label: 'Matières recyclées', items: [
                {name: 'Sac RPET recyclé', href: '/collections/eco-responsables'},
                {name: 'Stylo océan plastique', href: '/collections/eco-responsables'},
                {name: 'Carnet papier recyclé', href: '/collections/eco-responsables'}
              ]},
              { label: 'Bio & naturel', items: [
                {name: 'Tote bag coton bio', href: '/collections/eco-responsables'},
                {name: 'Gourde inox durable', href: '/collections/eco-responsables'},
                {name: 'Bambou & liège', href: '/collections/eco-responsables'}
              ]},
              { label: 'Circuits courts', items: [
                {name: 'Produits locaux', href: '/collections/eco-responsables'},
                {name: 'Packaging kraft', href: '/collections/eco-responsables'},
                {name: 'Livraison neutre carbone', href: '/collections/eco-responsables'}
              ]}
            ]
          }
        }
      ]
    },

    standards: {
      title: 'Standards',
      color: '#6366F1',
      cats: [
        {
          id: 'fournitures', icon: '\u{1F4CE}', label: 'Fournitures bureau',
          sub: 'Papeterie, consommables, rangement',
          href: '/collections/fournitures-de-bureau',
          preview: {
            titre: 'Fournitures bureau',
            tag: 'Standards \u00b7 Livraison 48h',
            img: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=400&q=80',
            groups: [
              { label: 'Papeterie', items: ['Ramettes A4 recycl\u00e9', 'Enveloppes kraft', 'Chemises cartonn\u00e9es'] },
              { label: 'Consommables', items: ['Cartouches encre recycl\u00e9es', 'Toner compatible', 'Rubans correcteurs'] },
              { label: 'Rangement', items: ['Bo\u00eetes archives', 'Classeurs ESAT', 'Organiseurs bureau'] }
            ]
          }
        },
        {
  id: 'hygiene', icon: '\u{1F9F4}', label: 'Hygi\u00e8ne & entretien',
  sub: 'Produits m\u00e9nagers, \u00e9co-recharges, protection',
  href: '/collections/hygiene-entretien',
  preview: {
    titre: 'Hygi\u00e8ne & entretien',
    tag: 'Standards \u00b7 \u00c9co-certifi\u00e9s',
    img: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=400&q=80',
    groups: [
      { label: 'Mains & surfaces', items: [
        {name: 'Savon liquide', href: '/collections/hygiene-entretien-1',},
        {name: 'Gel hydroalcoolique', href: '/collections/hygiene-hygiene-des-mains-et-surfaces'},
        {name: 'Nettoyants surfaces', href: '/collections/hygiene-hygiene-des-mains-et-surfaces'}
      ]},
      { label: 'Sols & entretien', items: [
        {name: 'D\u00e9tergents sols', href: '/collections/hygiene-hygiene-des-sols'},
        {name: 'Balais & serpilli\u00e8res', href: '/collections/hygiene-hygiene-des-sols'},
        {name: 'D\u00e9graissants', href: '/collections/hygiene-hygiene-des-sols'}
      ]},
      { label: 'Cuisine', items: [
        {name: 'Produits cuisine', href: '/collections/hygiene-hygiene-des-cuisines'},
        {name: 'Essuie-tout', href: '/collections/hygiene-hygiene-des-cuisines'},
        {name: 'Vaisselle jetable', href: '/collections/hygiene-vaisselle-jetable-et-consommables'}
      ]},
      { label: 'Protection individuelle', items: [
        {name: 'Gants jetables', href: '/collections/hygiene-protection-individuelle'},
        {name: 'Masques', href: '/collections/hygiene-protection-individuelle'},
        {name: 'Fournitures m\u00e9dicales', href: '/collections/hygiene-fournitures-medicales'}
      ]}
    ]
  }
},
        {
          id: 'alimentation', icon: '\u{1F9FA}', label: 'Alimentation',
          sub: 'Colis gourmands, paniers, snacks',
          href: '/collections/colis-gourmands',
          preview: {
            titre: 'Alimentation & \u00c9picerie',
            tag: 'Standards \u00b7 Produits ESAT & EA',
            img: 'https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=400&q=80',
            groups: [
              { label: 'Colis gourmands', items: ['Colis terroir 12 pi\u00e8ces', 'Panier bio saison', 'Box chocolats'] },
              { label: 'Snacks bureau', items: ['Vrac fruits secs', 'Mix noix & graines', 'Barres c\u00e9r\u00e9ales'] },
              { label: 'Confitures', items: ['Confitures artisanales', 'Miel ESAT', 'Terrines & p\u00e2t\u00e9s'] }
            ]
          }
        },
        {
          id: 'boissons', icon: '\u2615', label: 'Boissons',
          sub: 'Caf\u00e9, th\u00e9, infusions, capsules',
          href: '/collections/all',
          preview: {
            titre: 'Boissons & Caf\u00e9s',
            tag: 'Standards \u00b7 ESAT torr\u00e9facteurs',
            img: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=400&q=80',
            groups: [
              { label: 'Caf\u00e9', items: ['Caf\u00e9 moulu 250g', 'Capsules compostables', 'Caf\u00e9 grain premium'] },
              { label: 'Th\u00e9 & infusions', items: ['Bo\u00eete th\u00e9s assortis', 'Infusions bio', 'Th\u00e9 vrac 100g'] },
              { label: 'Softs', items: ['Jus de fruits ESAT', 'Sirop artisanal', 'Boissons bio'] }
            ]
          }
        },
        {
          id: 'seeph', icon: '\u{1F397}\uFE0F', label: 'Packs SEEPH',
          sub: 'Kits, affiches, outils managers',
          href: '/collections/all',
          preview: {
            titre: 'Packs SEEPH',
            tag: 'Standards \u00b7 Kits pr\u00eats \u00e0 l\u2019emploi',
            img: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&q=80',
            groups: [
              { label: 'Communication', items: ['Kit affiches A3/A4', 'Roll-up SEEPH', 'Kakemono personnalis\u00e9'] },
              { label: 'Outils RH', items: ['Guide manager 20p', 'Quiz \u00e9quipe', 'Livret t\u00e9moignages'] },
              { label: 'Cadeaux', items: ['Tote bag SEEPH', 'Badge TH solidaire', "Pin's inclusion"] }
            ]
          }
        },
        {
          id: 'accessoires', icon: '\u{1F587}\uFE0F', label: 'Accessoires bureau',
          sub: 'Organiseurs, d\u00e9coration, pr\u00e9sentoirs',
          href: '/collections/all',
          preview: {
            titre: 'Accessoires bureau',
            tag: 'Standards \u00b7 Pr\u00eat \u00e0 l\u2019emploi',
            img: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=400&q=80',
            groups: [
              { label: 'Organiseurs', items: ['Organiseur bois', 'Porte-stylos bambou', 'Trieur courrier'] },
              { label: 'D\u00e9coration', items: ['Plante succulent ESAT', 'Cadre photo bois', 'Bougie artisanale'] }
            ]
          }
        }
      ]
    },

    services: {
      title: 'Services',
      color: '#F59E0B',
      cats: [
        {
          id: 'fruits', icon: '\u{1F34E}', label: 'Livraison de fruits',
          sub: 'Hebdo, mensuel, \u00e9v\u00e9nementiel',
          href: '/collections/all',
          preview: {
            titre: 'Livraison de fruits',
            tag: 'Service \u00b7 Abonnement sans engagement',
            img: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&q=80',
            groups: [
              { label: 'Abonnements', items: ['Panier hebdo 10 pers.', 'Panier bi-mensuel', 'Panier mensuel'] },
              { label: 'Formats', items: ['Mini (5 pers.)', 'Standard (15 pers.)', 'Grand (30+)'] },
              { label: 'Options', items: ['100% bio', 'Fruits exotiques', 'Mixte fruits & snacks'] }
            ]
          }
        },
        {
          id: 'recyclage', icon: '\u267B\uFE0F', label: 'Recyclage & collecte',
          sub: 'Cartouches, batteries, \u00e9lectronique',
          href: '/collections/all',
          preview: {
            titre: 'Recyclage & collecte',
            tag: 'Service \u00b7 Collecte sur site',
            img: 'https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=400&q=80',
            groups: [
              { label: '\u00c9lectronique', items: ['Collecte cartouches', 'Collecte batteries', 'Collecte c\u00e2bles'] },
              { label: 'Papier', items: ['Bac confidentialit\u00e9', 'Collecte archives', 'Destruction s\u00e9curis\u00e9e'] }
            ]
          }
        },
        {
          id: 'formations', icon: '\u{1F393}', label: 'Formations & ateliers',
          sub: 'Sensibilisation handicap, SEEPH',
          href: '/collections/all',
          preview: {
            titre: 'Formations & ateliers',
            tag: 'Service \u00b7 Pr\u00e9sentiel & distanciel',
            img: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=400&q=80',
            groups: [
              { label: 'Sensibilisation', items: ['Atelier 2h handicap', 'Formation managers 1j', 'Conf\u00e9rence SEEPH'] },
              { label: 'Certifiantes', items: ['Formation DOETH 3h', 'OPCO finan\u00e7able', 'Attestation d\u00e9livr\u00e9e'] }
            ]
          }
        },
        {
          id: 'conditionnement', icon: '\u{1F4E6}', label: 'Conditionnement',
          sub: 'Assemblage, kitting, logistique',
          href: '/collections/all',
          preview: {
            titre: 'Conditionnement & logistique',
            tag: 'Service \u00b7 Sur devis',
            img: 'https://images.unsplash.com/photo-1553413077-190dd305871c?w=400&q=80',
            groups: [
              { label: 'Kitting', items: ['Assemblage coffrets', 'Kit \u00e9v\u00e9nementiel', 'Box personnalis\u00e9e'] },
              { label: 'Logistique', items: ['Stockage ESAT', 'Pr\u00e9paration commandes', 'Co-packing'] }
            ]
          }
        },
        {
          id: 'tih', icon: '\u{1F4BB}', label: 'TIH \u2014 Prestations',
          sub: 'Dev, design, conseil, r\u00e9daction',
          href: '/collections/all',
          preview: {
            titre: 'Prestations TIH',
            tag: 'Service \u00b7 100% d\u00e9ductible DOETH',
            img: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&q=80',
            groups: [
              { label: 'Digital', items: ['D\u00e9veloppement web/app', 'Design graphique', 'R\u00e9seaux sociaux'] },
              { label: 'Conseil', items: ['R\u00e9daction web SEO', 'Traduction', 'Conseil strat\u00e9gique'] }
            ]
          }
        },
        {
          id: 'espaces-verts', icon: '\u{1F333}', label: 'Espaces verts',
          sub: 'Entretien, am\u00e9nagement ESAT',
          href: '/collections/all',
          preview: {
            titre: 'Espaces verts ESAT',
            tag: 'Service \u00b7 Contrat annuel ou ponctuel',
            img: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&q=80',
            groups: [
              { label: 'Entretien', items: ['Tonte & d\u00e9broussaillage', 'Taille haies', 'Arrosage & soins'] },
              { label: 'Am\u00e9nagement', items: ['Cr\u00e9ation massifs', 'Potager collectif', 'Jardini\u00e8res balcon'] }
            ]
          }
        },
        {
          id: 'audit-pmr', icon: '♿', label: 'Audit accessibilite PMR',
          sub: 'Diagnostic locaux, conformite ERP',
          href: '/pages/audit-accessibilite-pmr-entreprise',
          preview: {
            titre: 'Audit accessibilite PMR',
            tag: 'Service · Expertise TIH certifiee',
            img: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?w=400&q=80',
            groups: [
              { label: 'Diagnostic', items: [
                {name: 'Entrees & cheminements', href: '/pages/audit-accessibilite-pmr-entreprise'},
                {name: 'Sanitaires PMR', href: '/pages/audit-accessibilite-pmr-entreprise'},
                {name: 'Signaletique & alertes', href: '/pages/audit-accessibilite-pmr-entreprise'}
              ]},
              { label: 'Livrables', items: [
                {name: 'Rapport detaille', href: '/pages/audit-accessibilite-pmr-entreprise'},
                {name: 'Plan action priorise', href: '/pages/audit-accessibilite-pmr-entreprise'},
                {name: 'Attestation DOETH', href: '/pages/audit-accessibilite-pmr-entreprise'}
              ]}
            ]
          }
        },
        {
          id: 'audit-numerique', icon: '🖥️', label: 'Audit accessibilite numerique',
          sub: 'RGAA, WCAG, site & applications',
          href: '/pages/audit-accessibilite-numerique-rgaa',
          preview: {
            titre: 'Audit accessibilite numerique',
            tag: 'Service · RGAA & WCAG 2.1',
            img: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=400&q=80',
            groups: [
              { label: 'Ce qu on audite', items: [
                {name: 'Audit RGAA 106 criteres', href: '/pages/audit-accessibilite-numerique-rgaa'},
                {name: 'Navigation clavier', href: '/pages/audit-accessibilite-numerique-rgaa'},
                {name: 'Lecteurs d ecran', href: '/pages/audit-accessibilite-numerique-rgaa'}
              ]},
              { label: 'Livrables', items: [
                {name: 'Rapport de conformite', href: '/pages/audit-accessibilite-numerique-rgaa'},
                {name: 'Plan de correction', href: '/pages/audit-accessibilite-numerique-rgaa'},
                {name: 'Attestation DOETH', href: '/pages/audit-accessibilite-numerique-rgaa'}
              ]}
            ]
          }
        }
      ]
    }
  };

  /* ── Override with Customizer data if available ── */
  var _megaBlocksEl = document.getElementById('mega-cat-blocks');
  if (_megaBlocksEl) {
    try {
      var _dyn = JSON.parse(_megaBlocksEl.textContent);
      if (_dyn.categories && _dyn.categories.length > 0) {
        CATALOGUE_DATA = {
          personnalisable: { title: 'Personnalisable', color: '#18A06A', cats: [] },
          standards: { title: 'Standards', color: '#6366F1', cats: [] },
          services: { title: 'Services', color: '#F59E0B', cats: [] }
        };
        _dyn.categories.forEach(function(cat) {
          var items = [];
          if (cat.preview_items) {
            cat.preview_items.split('\n').forEach(function(line) {
              line = line.trim();
              if (!line) return;
              var parts = line.split('|');
              items.push({ label: parts[0].trim(), href: (parts[1] || '/collections/all').trim() });
            });
          }
          var entry = {
            id: cat.label.toLowerCase().replace(/[^a-z0-9]/g, '-'),
            icon: cat.icon,
            label: cat.label,
            sub: cat.sub,
            href: cat.href,
            preview: {
              titre: cat.preview_title,
              tag: cat.preview_tag,
              img: cat.preview_image,
              groups: items.length > 0 ? [{ label: '', items: items }] : []
            }
          };
          if (CATALOGUE_DATA[cat.parent]) {
            CATALOGUE_DATA[cat.parent].cats.push(entry);
          }
        });
      }
    } catch(e) { /* fallback to hardcoded data */ }
  }

  /* ── Apply image overrides from Customizer ── */
  if (_megaBlocksEl) {
    try {
      var _ovr = JSON.parse(_megaBlocksEl.textContent);
      if (_ovr.image_overrides && _ovr.image_overrides.length > 0) {
        _ovr.image_overrides.forEach(function(ov) {
          ['personnalisable','standards','services'].forEach(function(sec) {
            CATALOGUE_DATA[sec].cats.forEach(function(cat) {
              if (cat.id === ov.id) {
                cat.preview.img = ov.img;
              }
            });
          });
        });
      }
    } catch(e) {}
  }

  /* ── DOM ELEMENTS ── */
  var elSectionTitle = document.getElementById('mega-cat-section-title');
  var elSubcats = document.getElementById('mega-cat-subcats');
  var elPreviewTitle = document.getElementById('mega-preview-title');
  var elPreviewTag = document.getElementById('mega-preview-tag');
  var elPreviewSubcats = document.getElementById('mega-preview-subcats');
  var elPreviewImgTitle = document.getElementById('mega-preview-img-title');
  var elPreviewImg = document.getElementById('mega-cat-preview-img');
  var elPreviewBadge = document.getElementById('mega-preview-section-badge');

  /* ── Fix hrefs collections ── */
var HREF_MAP = {
  'textile': '/collections/textile',
  'sacs': '/collections/sacs-tote-bags',
  'gourdes-mugs': '/collections/gourdes-mugs',
  'stylos-papeterie': '/collections/papeterie',
  'high-tech': '/collections/high-tech',
  'cadeaux': '/collections/cadeaux',
  'accessoires-divers': '/collections/accessoires-divers',
  'france': '/collections/made-in-france',
  'eco': '/collections/eco-responsables',
  'fournitures': '/collections/fournitures-de-bureau',
'hygiene': '/collections/hygiene-entretien-1',
'alimentation': '/collections/colis-gourmands',
  'boissons': '/collections/boissons',
  'seeph': '/collections/packs-seeph',
  'accessoires': '/collections/accessoires-bureau',
  'fruits': '/pages/livraison-fruits-entreprise-esat',
  'recyclage': '/pages/recyclage-entreprise-esat',
  'formations': '/pages/formation-sensibilisation-handicap-entreprise',
  'conditionnement': '/pages/conditionnement-sous-traitance-esat',
  'tih': '/pages/prestations-digitales-tih-doeth',
  'espaces-verts': '/pages/espaces-verts-entreprise-esat',
'audit-pmr': '/pages/audit-accessibilite-pmr-entreprise',
'audit-numerique': '/pages/audit-accessibilite-numerique-rgaa'
};
['personnalisable','standards','services'].forEach(function(sec) {
  CATALOGUE_DATA[sec].cats.forEach(function(cat) {
    if (HREF_MAP[cat.id]) cat.href = HREF_MAP[cat.id];
  });
});

  var currentSectionId = 'personnalisable';

  /* ── UPDATE PREVIEW (col3) ── */
  function updatePreview(sectionId, catIdx) {
    var section = CATALOGUE_DATA[sectionId];
    if (!section) return;
    var cat = section.cats[catIdx];
    if (!cat || !cat.preview) return;
    var p = cat.preview;

    if (elPreviewTitle) elPreviewTitle.textContent = p.titre;
    if (elPreviewTag) {
      elPreviewTag.textContent = p.tag;
      elPreviewTag.style.color = section.color;
    }
    if (elPreviewImgTitle) elPreviewImgTitle.textContent = p.titre;

    if (elPreviewImg) {
      var bgDiv = elPreviewImg.querySelector('div');
      if (bgDiv) bgDiv.style.backgroundImage = 'url(' + p.img + ')';
    }

    if (elPreviewBadge) {
      elPreviewBadge.textContent = section.title;
      elPreviewBadge.style.background = section.color;
    }

    if (elPreviewSubcats) {
      elPreviewSubcats.style.gridTemplateColumns = p.groups.length > 4 ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)';
      var html = '';
      for (var g = 0; g < p.groups.length; g++) {
        var group = p.groups[g];
        html += '<div>';
        var groupHref = group.items && group.items[0] && group.items[0].href ? group.items[0].href : cat.href;
html += '<a href="' + groupHref + '" style="display:block;font-size:13px;font-weight:700;color:var(--ink);letter-spacing:.5px;margin-bottom:8px;text-decoration:none;">' + group.label + ' →</a>';        for (var it = 0; it < group.items.length; it++) {
html += '<a href="' + (group.items[it].href || cat.href) + '" style="display:block;font-size:14px;color:var(--ink-60);padding:3px 0;text-decoration:none;cursor:pointer;">' + (group.items[it].name || group.items[it]) + '</a>';
        }
        html += '</div>';
      }
      elPreviewSubcats.innerHTML = html;
    }

    var catLink = elPreviewImg ? elPreviewImg.querySelector('a') : null;
    if (catLink) catLink.href = cat.href;
  }

  /* ── UPDATE SUBCATEGORIES (col2) with icons ── */
  function updateSubcats(sectionId) {
    var section = CATALOGUE_DATA[sectionId];
    if (!section || !elSubcats) return;

    if (elSectionTitle) elSectionTitle.textContent = section.title;
    elSubcats.style.setProperty('--section-color', section.color);

    var html = '';
    for (var i = 0; i < section.cats.length; i++) {
      var cat = section.cats[i];
      var isFirst = (i === 0);
      html += '<div class="mega-cat-subcat' + (isFirst ? ' active' : '') + '" data-cat-idx="' + i + '" data-href="' + cat.href + '">';
html += '<div style="width:36px;height:36px;border-radius:10px;background:' + section.color + '12;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;">' + (cat.icon || '') + '</div>';
      html += '<div style="flex:1;min-width:0;">';
      html += '<div class="mega-cat-subcat-label">' + cat.label + '</div>';
      html += '<div style="font-size:10px;color:var(--ink-30);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + cat.sub + '</div>';
      html += '</div>';
      html += '</div>';
    }
    elSubcats.innerHTML = html;

    updatePreview(sectionId, 0);
    bindSubcatHovers(sectionId);
  }

  /* ── BIND SUBCAT HOVERS — CSS classes only ── */
  function bindSubcatHovers(sectionId) {
    if (!elSubcats) return;
    var subcats = elSubcats.querySelectorAll('.mega-cat-subcat');
    var section = CATALOGUE_DATA[sectionId];
    if (!section) return;

    subcats.forEach(function(sub) {
      sub.addEventListener('mouseenter', function() {
        subcats.forEach(function(s) { s.classList.remove('active'); });
        this.classList.add('active');
        var idx = parseInt(this.getAttribute('data-cat-idx')) || 0;
        updatePreview(sectionId, idx);
      });
    });
  }

  /* ── SECTION SWITCHING (col1 hover) ── */
  catSections.forEach(function(sec) {
    sec.addEventListener('mouseenter', function() {
      var sectionId = this.getAttribute('data-section');
      if (!sectionId) return;
      currentSectionId = sectionId;

      var section = CATALOGUE_DATA[sectionId];
      if (!section) return;

      catSections.forEach(function(s) {
        s.classList.remove('active');
        s.style.background = '';
        s.style.borderLeftColor = 'transparent';
        var svg = s.querySelector('svg');
        if (svg) {
          svg.querySelectorAll('path, circle, rect, line, polyline, polygon').forEach(function(el) {
            el.setAttribute('stroke', 'var(--ink-30)');
          });
        }
        var lbl = s.querySelector('.mega-cat-section-label');
        if (lbl) { lbl.style.fontWeight = ''; lbl.style.color = ''; }
      });

      this.classList.add('active');
      this.style.background = '#fff';
      this.style.borderLeftColor = section.color;

      var svg = this.querySelector('svg');
      if (svg) {
        svg.querySelectorAll('path, circle, rect, line, polyline, polygon').forEach(function(el) {
          el.setAttribute('stroke', section.color);
        });
      }

      var lbl = this.querySelector('.mega-cat-section-label');
      if (lbl) { lbl.style.fontWeight = '700'; lbl.style.color = 'var(--ink)'; }

      updateSubcats(sectionId);
    });
  });

  /* ── INIT + click delegation via mousedown ── */
  if (elSubcats) {
    updateSubcats('personnalisable');
    elSubcats.addEventListener('mousedown', function(e) {
      var subcat = e.target.closest('.mega-cat-subcat');
      if (subcat && subcat.dataset.href) {
        window.location.href = subcat.dataset.href;
      }
    });
  }


  /* ══════════════════════════════════════════════════════════
     FAQ ACCORDION
     ══════════════════════════════════════════════════════════ */
  document.addEventListener('click', function(e) {
    var faqQ = e.target.closest('.faq-q');
    if (!faqQ) return;
    var item = faqQ.closest('.faq-item');
    if (item) item.classList.toggle('open');
  });


  /* ══════════════════════════════════════════════════════════
     SIMULATOR — Range sliders
     ══════════════════════════════════════════════════════════ */
  var simEffectif = document.getElementById('sim-effectif');
  var simTaux = document.getElementById('sim-taux');
  var simBudget = document.getElementById('sim-budget');

  function updateSimulator() {
    if (!simEffectif || !simTaux || !simBudget) return;

    var effectif = parseInt(simEffectif.value) || 250;
    var taux = parseFloat(simTaux.value) || 0;
    var budget = parseInt(simBudget.value) || 100;

    var labels = document.querySelectorAll('.sim-field .sim-lbl span');
    if (labels[0]) labels[0].textContent = effectif.toLocaleString('fr-FR') + ' sal.';
    if (labels[1]) labels[1].textContent = taux.toFixed(1) + '%';
    if (labels[2]) labels[2].textContent = (budget * 100).toLocaleString('fr-FR') + ' \u20ac';

    var manquants = Math.max(0, effectif * 0.06 - effectif * taux / 100);
    var contrib = Math.round(manquants * 5000);
    var achats = budget * 100;
    var deduc = Math.min(achats, Math.round(contrib * 0.75));
    var eco = deduc;

    var fmt = function(n) { return n.toLocaleString('fr-FR'); };

    var results = document.querySelectorAll('.sim-result .sim-val');
    if (results.length >= 3) {
      results[0].textContent = fmt(contrib) + ' \u20ac';
      results[1].textContent = '-' + fmt(deduc) + ' \u20ac';
      results[2].textContent = fmt(eco) + ' \u20ac';
    }

    var alertEl = document.getElementById('sim-alert');
    if (alertEl) {
      if (taux === 0) {
        alertEl.style.display = 'block';
      } else {
        alertEl.style.display = 'none';
      }
    }
  }

  if (simEffectif) simEffectif.addEventListener('input', updateSimulator);
  if (simTaux) simTaux.addEventListener('input', updateSimulator);
  if (simBudget) simBudget.addEventListener('input', updateSimulator);


  /* ══════════════════════════════════════════════════════════
     TESTI2 THUMBNAIL SWITCHING
     ══════════════════════════════════════════════════════════ */
  var testiThumbs = document.querySelectorAll('.testi2-thumb');
  testiThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      testiThumbs.forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');

      var card = document.querySelector('.testi2-card');
      if (!card) return;

      var photo = this.getAttribute('data-photo');
      var company = this.getAttribute('data-company');
      var quote = this.getAttribute('data-quote');
      var author = this.getAttribute('data-author');
      var role = this.getAttribute('data-role');
      var m1val = this.getAttribute('data-m1val');
      var m1lbl = this.getAttribute('data-m1lbl');
      var m2val = this.getAttribute('data-m2val');
      var m2lbl = this.getAttribute('data-m2lbl');

      if (photo) { var img = card.querySelector('.testi2-photo'); if (img) img.src = photo; }
      if (company) { var logo = card.querySelector('.testi2-logo'); if (logo) logo.textContent = company; }
      if (quote) { var q = card.querySelector('.testi2-quote'); if (q) q.textContent = '\u201C' + quote + '\u201D'; }
      if (author) { var a = card.querySelector('.testi2-author strong'); if (a) a.textContent = author; }
      if (role) { var r = card.querySelector('.testi2-role'); if (r) r.textContent = role; }

      var vals = card.querySelectorAll('.testi2-metric-val');
      var lbls = card.querySelectorAll('.testi2-metric-lbl');
      if (m1val && vals[0]) vals[0].textContent = m1val;
      if (m1lbl && lbls[0]) lbls[0].textContent = m1lbl;
      if (m2val && vals[1]) vals[1].textContent = m2val;
      if (m2lbl && lbls[1]) lbls[1].textContent = m2lbl;
    });
  });


  /* ══════════════════════════════════════════════════════════
     INTERSECTION OBSERVER — fade up on scroll
     ══════════════════════════════════════════════════════════ */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('anim-1');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.observe-fade').forEach(function(el) {
      observer.observe(el);
    });
  }
  
/* ── MOBILE MENU ACCORDION ── */
  var mobCatTrigger = document.getElementById('mob-cat-trigger');
  if (mobCatTrigger) {
    mobCatTrigger.addEventListener('click', function() {
      this.classList.toggle('open');
    });
  }
})();

/* ════════════════════════════════════════════
   MAKE WEBHOOK + KLAVIYO DIRECT — ImpacTH forms
   ════════════════════════════════════════════ */
(function(){
  const MAKE_WEBHOOK = 'https://hook.eu1.make.com/73mvfj35zpnfb1gitkf8m4mf8jy59ne9';
  const KLAVIYO_COMPANY_ID = 'XikCty';
  const KLAVIYO_REVISION = '2024-02-15';
  const LIST_PROSPECT_SERVICES = 'WAtLrL';
  const LIST_NEWSLETTER = 'YukHpL';

  function detectFormType() {
    const p = window.location.pathname;
    if (p.includes('/pages/contact')) return 'expert';
    if (p.includes('/pages/simulateur-doeth')) return 'simulateur';
    const services = ['fruits','recyclage','formation','conditionnement','tih','prestations-digitales','espaces-verts','audit-accessibilite'];
    if (services.some(s => p.includes(s))) return 'service';
    return null;
  }

  function detectServiceName() {
    const p = window.location.pathname;
    if (p.includes('fruits')) return 'Livraison de fruits';
    if (p.includes('recyclage')) return 'Recyclage & collecte';
    if (p.includes('formation')) return 'Formations & ateliers';
    if (p.includes('conditionnement')) return 'Conditionnement';
    if (p.includes('tih') || p.includes('prestations-digitales')) return 'TIH — Prestations';
    if (p.includes('espaces-verts')) return 'Espaces verts';
    if (p.includes('audit-accessibilite-pmr')) return 'Audit accessibilité PMR';
    if (p.includes('audit-accessibilite-numerique')) return 'Audit accessibilité numérique';
    return null;
  }

  function sourceLabel(t) {
    return { expert:'Parler à expert', service:'Demande Service', simulateur:'Simulateur DOETH' }[t] || 'Autre';
  }

  function getAllFormData(fd) {
    const obj = {};
    for (const [k, v] of fd.entries()) {
      if (!v || k === 'form_type' || k === 'utf8') continue;
      let ck = k.replace(/^contact\[body\]\[(.+)\]$/, '$1').replace(/^contact\[(.+)\]$/, '$1');
      obj[ck] = v;
    }
    return obj;
  }

  function splitName(full) {
    const parts = (full || '').trim().split(/\s+/);
    return { first: parts[0] || '', last: parts.slice(1).join(' ') };
  }

  function sendToKlaviyo(listId, email, phone, firstName, lastName, properties, customSource) {
    const profileAttrs = { email: email, properties: properties || {} };
    if (firstName) profileAttrs.first_name = firstName;
    if (lastName)  profileAttrs.last_name  = lastName;
    if (phone)     profileAttrs.phone_number = phone;

    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource || 'Formulaire impacth.fr',
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(body)
    }).then(r => {
      if (r.status === 202) {
        console.log(`[Klaviyo] ✓ ${listId} ${email}`);
        return true;
      }
      return r.text().then(t => {
        console.error(`[Klaviyo] ✗ ${listId} status=${r.status}`, t);
        return false;
      });
    }).catch(err => {
      console.error(`[Klaviyo] ✗ ${listId}`, err);
      return false;
    });
  }

  function showSuccess(form) {
    form.style.transition = 'opacity .3s ease';
    form.style.opacity = '0';
    setTimeout(() => {
      form.style.display = 'none';
      const isDark = form.closest('.srv-form-wrap') !== null;
      const box = document.createElement('div');
      box.style.cssText = isDark
        ? 'text-align:center;padding:48px 24px;background:rgba(110,232,154,.08);border:1px solid rgba(110,232,154,.3);border-radius:12px;color:#fff;'
        : 'text-align:center;padding:48px 24px;background:#E8F8F1;border:1px solid #18A06A33;border-radius:12px;color:#0d1f14;';
      const titleColor = isDark ? '#fff' : '#0d1f14';
      const textColor = isDark ? 'rgba(255,255,255,.75)' : '#5a7060';
      const subColor = isDark ? 'rgba(255,255,255,.55)' : '#6b8070';
      box.innerHTML = `
        <div style="font-size:56px;margin-bottom:16px;">✓</div>
        <h3 style="font-family:'Bricolage Grotesque',sans-serif;font-size:24px;font-weight:800;color:${titleColor};margin:0 0 12px;">Demande envoyée !</h3>
        <p style="color:${textColor};font-size:15px;line-height:1.6;margin:0 0 8px;">Merci, nous avons bien reçu votre demande.</p>
        <p style="color:${subColor};font-size:14px;margin:0;">Un expert ImpacTH vous recontacte sous 48h avec votre devis personnalisé.</p>
      `;
      form.parentElement.insertBefore(box, form);
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  }

  document.addEventListener('submit', function(e) {
    const form = e.target;
    const isContact = form.querySelector('input[name="form_type"][value="contact"]');
    if (!isContact) return;
    const eventType = detectFormType();
    if (!eventType) return;

    e.preventDefault();
    e.stopPropagation();

    const btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Envoi en cours...'; }

    const fd = new FormData(form);
    const allData = getAllFormData(fd);
    const serviceName = eventType === 'service' ? detectServiceName() : null;
    const source = sourceLabel(eventType);

    const payload = {
      type: eventType,
      source: source,
      service: serviceName,
      page_url: window.location.href,
      page_title: document.title,
      timestamp: new Date().toISOString(),
      ...allData
    };

    // 1. Make → Monday + Gmail (inchangé)
    const makePromise = fetch(MAKE_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      mode: 'no-cors'
    }).then(() => console.log('[Make] ✓ Envoyé', payload))
      .catch(err => console.error('[Make] ✗', err));

    // 2. Klaviyo → profile upsert + subscribe aux 2 listes (déclenche le Flow)
    const klaviyoPromises = [];
    const email = allData.email;
    if (email) {
      const { first, last } = splitName(allData.name);
      const props = {
        entreprise: allData.entreprise,
        telephone: allData.telephone,
        ville: allData.ville,
        effectif: allData.effectif,
        frequence: allData.frequence,
        format: allData.format,
        message: allData.message,
        service: serviceName,
        source: source,
        type: eventType,
        page_url: window.location.href,
        page_title: document.title,
        last_form_timestamp: new Date().toISOString()
      };
      Object.keys(props).forEach(k => { if (!props[k]) delete props[k]; });
      const customSource = 'Form ' + (serviceName || source);

      klaviyoPromises.push(sendToKlaviyo(LIST_PROSPECT_SERVICES, email, allData.telephone, first, last, props, customSource));
      klaviyoPromises.push(sendToKlaviyo(LIST_NEWSLETTER,        email, allData.telephone, first, last, props, customSource));

    } else {
      console.warn('[Klaviyo] skipped — pas d email dans le form');
    }

    Promise.allSettled([makePromise, ...klaviyoPromises]).finally(() => showSuccess(form));

    return false;
  }, true);

  window.pushSimulateurToMake = function(data) {
    var SIM_WEBHOOK = 'https://hook.eu1.make.com/pruxjywsoikpo42jggvsvb3o97bjo6mu';
    return fetch(SIM_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'simulateur',
        source: 'Simulateur DOETH',
        page_url: window.location.href,
        timestamp: new Date().toISOString(),
        ...data
      }),
      mode: 'no-cors'
    });
  };

  console.log('[Make+Klaviyo] JS prêt');
})();